import React, { forwardRef } from 'react'

import { BaseButton, type BaseButtonProps } from './BaseButton'

export interface ButtonProps
  extends BaseButtonProps, Omit<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    'className'
  > {
  children: React.ReactNode;
  disabled?: boolean;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  children,
  disabled,
  type = 'button',
  ...props
}, forwardedRef) => {
  return (
    <BaseButton {...props}>
      <button ref={forwardedRef} disabled={disabled} type={type}>
        {children}
      </button>
    </BaseButton>
  )
})
